import { httpGet, httpPost, httpDelete } from './api/axios_api';
import { Buffer } from 'buffer';
import Constants from '../constants/constants';
import axios from 'axios';
import defaultImage from '../static/assets/restore_mini_logo.png';

const actions = {
  getCommunicationsList: 'GET_ADVERTISEMENTS_LIST',
};

export async function get_active_ads() {
  return httpGet(`${Constants.BACKEND_URL}/communications/get_active_ads`, {}, '');
}

export async function get_ads(query, filterType, offset, limit) {
  return httpGet(`${Constants.BACKEND_URL}/communications/get_ads`, {
    params: { offset, limit, communication_type: filterType, query },
  });
}

export async function getCommunicationById(communicationId) {
  return httpGet(`${Constants.BACKEND_URL}/communications/${communicationId}`, {});
}

export function upsertCommunication(communication) {
  return httpPost(`${Constants.BACKEND_URL}/communications/`, communication);
}

export async function deleteCommunication(communicationId) {
  return httpDelete(`${Constants.BACKEND_URL}/communications/${communicationId}`, {});
}

export async function getWelcomePopup() {
  return httpGet(`${Constants.BACKEND_URL}/communications/welcome_popup`, {}, '');
}

export async function getDashboardBanner() {
  return httpGet(`${Constants.BACKEND_URL}/communications/dashboard_banner`, {});
}

export async function loadImageFromUrl(imageName) {
  try {
    if (imageName === undefined) {
      return { success: false, imageData: defaultImage };
    } else {
      const response = await axios.get(`${window.location.origin}/content/communications/${imageName}`, {
        responseType: 'arraybuffer',
      });

      if (response && response.status && response.status === Constants.HTTP_OK) {
        const dec = new TextDecoder();
        const decoded_data = dec.decode(response.data);

        if (typeof decoded_data === 'string' && decoded_data.startsWith('<!doctype html>')) {
          throw new Error('Image not found');
        }

        const raw = Buffer.from(response.data).toString('base64');
        const base64String = 'data:' + response.headers['content-type'] + ';base64,' + raw;

        return { success: true, imageData: base64String };
      }
    }
  } catch (e) {
    console.error(`Error loading image: ${e}`);
    return { success: false, imageData: defaultImage };
  }
}

const INITIAL_STATE = {
  communications: [],
};

export default function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actions.getCommunicationsList:
      return {
        ...state,
        ...action.data,
      };
    default:
      return { ...state };
  }
}
